import { Components } from 'src/components';
import { setComponentAttributes } from 'shared/storybook-utils';

export default {
  title: 'Components/Badge',
  component: 'a1-badge',
  tags: ['autodocs'],
  parameters: {
    docs: {
      description: {
        component: 'Content Component - Used to show a status or a tag.',
      },
    },
    layout: 'centered',
  },
};

const elementName = 'a1-badge';

const Template = (args: Components.A1Badge): HTMLA1BadgeElement => {
  const elComponent = document.createElement(elementName);

  Object.entries(args).forEach(([key, value]) => {
    setComponentAttributes({ element: elComponent, key, value });
  });

  return elComponent;
};

export const SingleCharacter: Story<Components.A1Badge> = Template.bind({});
SingleCharacter.args = {
  text: 'Y',
};

export const Yellow: Story<Components.A1Badge> = Template.bind({});
Yellow.args = {
  text: 'Yellow',
  color: 'yellow',
};

export const Orange: Story<Components.A1Badge> = Template.bind({});
Orange.args = {
  text: 'Orange',
  color: 'orange',
};

export const Red: Story<Components.A1Badge> = Template.bind({});
Red.args = {
  text: 'Red',
  color: 'red',
};

export const Purple: Story<Components.A1Badge> = Template.bind({});
Purple.args = {
  text: 'Purple',
  color: 'purple',
};

export const Blue: Story<Components.A1Badge> = Template.bind({});
Blue.args = {
  text: 'Blue',
  color: 'blue',
};

export const Aqua: Story<Components.A1Badge> = Template.bind({});
Aqua.args = {
  text: 'Aqua',
  color: 'aqua',
};

export const Teal: Story<Components.A1Badge> = Template.bind({});
Teal.args = {
  text: 'Teal',
  color: 'teal',
};

export const Green: Story<Components.A1Badge> = Template.bind({});
Green.args = {
  text: 'Green',
  color: 'green',
};

export const Gray: Story<Components.A1Badge> = Template.bind({});
Gray.args = {
  text: 'Gray',
  color: 'gray',
};

export const Disabled: Story<Components.A1Badge> = Template.bind({});
Disabled.args = {
  text: 'Disabled',
  color: 'disabled',
};

export const YellowAttention: Story<Components.A1Badge> = Template.bind({});
YellowAttention.args = {
  text: 'Yellow Attention',
  type: 'attention',
  color: 'yellow',
};

export const OrangeAttention: Story<Components.A1Badge> = Template.bind({});
OrangeAttention.args = {
  text: 'Orange Attention',
  type: 'attention',
  color: 'orange',
};

export const RedAttention: Story<Components.A1Badge> = Template.bind({});
RedAttention.args = {
  text: 'Red Attention',
  type: 'attention',
  color: 'red',
};

export const PurpleAttention: Story<Components.A1Badge> = Template.bind({});
PurpleAttention.args = {
  text: 'Purple Attention',
  type: 'attention',
  color: 'purple',
};

export const BlueAttention: Story<Components.A1Badge> = Template.bind({});
BlueAttention.args = {
  text: 'Blue Attention',
  type: 'attention',
  color: 'blue',
};

export const AquaAttention: Story<Components.A1Badge> = Template.bind({});
AquaAttention.args = {
  text: 'Aqua Attention',
  type: 'attention',
  color: 'aqua',
};

export const TealAttention: Story<Components.A1Badge> = Template.bind({});
TealAttention.args = {
  text: 'Teal Attention',
  type: 'attention',
  color: 'teal',
};

export const GreenAttention: Story<Components.A1Badge> = Template.bind({});
GreenAttention.args = {
  text: 'Green Attention',
  type: 'attention',
  color: 'green',
};

export const GrayAttention: Story<Components.A1Badge> = Template.bind({});
GrayAttention.args = {
  text: 'Gray Attention',
  type: 'attention',
  color: 'gray',
};

export const DisabledAttention: Story<Components.A1Badge> = Template.bind({});
DisabledAttention.args = {
  text: 'Disabled',
  type: 'attention',
  color: 'disabled',
};
